import {IFormController} from 'angular';

export function barColourReverse(percent: number) {
    percent = Math.min(percent, 1);
    return 'hsl(' + Math.round(120 * percent) + ', 70%, 45%)';
}

export function touchInputsInError(form: IFormController) {
    if (!form || !form.$error) {
        return;
    }
    angular.forEach(form.$error, (error: any) => {
        angular.forEach(error, (field: any) => {
            field.$setTouched();
        });
    });
}
